<template>
  <div v-if="show" class="animated fadeIn" ref="container">
    <vs-table
      ref="table"
      :params="params"
      :options="options"
      @onCreateHeaderActionClicked="createBankAccount"
    ></vs-table>
    <div ref="container"></div>
  </div>
</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import EventBus from "../bus.js";
  import Vue from "vue";
  import BankAccountsModalButton from "../components/BankAccountsModalButton.vue";

  export default {
    name: "bank-account",
    created: () => {
    },
    components: {
      VsTable
    },

    data() {
      return {
        access: {},
        show: true,
        params: {
          entity: "accounts",
          list: [],
          headers: {
            code: {
              title: "کد",
              type: "text"
            },
            description: {
              title: "شرح",
              type: "text"
            },
            Currency: {
              title: "نوع ارز ",
              type: "text"
            },
            branchName: {
              title: "نام شعبه",
              type: "text"
            },
            branchCode: {
              title: "کد شعبه",
              type: "text"
            },
            AccountNumber: {
              title: "شماره حساب",
              type: "text"
            },
            accountType: {
              title: "نوع حساب",
              type: "text"
            },
            BackupNumber: {
              title: "حساب پشتیبان",
              type: "text"
            },

          }
        },
        options: {
          hasActions: true,
          hasActionsInHeader: true,
          onCreateHeaderActionClicked: true,
          clickableRows: true,
          getTopRightButtons: () => {
            let arr = [];

            let addItemButton = {
              component: "bank-accounts-modal-button",
              params: {
                mode: "create"
              }
            };
            arr.push(addItemButton);

            return arr;
          },
          onRowDoubleClicked: row => {
            this.viewBankAccount(row);
          },
          onRowClicked: row => {
            //EventBus.$emit('onRowToggleLoadingView', row.id);
            /*new BaseService('discounts').getById(row.id).then(response => {
                              let ComponentClass = Vue.extend(DiscountModalButton);
                              let modalButton = new ComponentClass({
                                  propsData: {
                                      params: {
                                          mode: 'view'
                                      }
                                  }
                              });
                              modalButton.$data.discount = response.data;
                              modalButton.$mount();
                              this.$refs.container.appendChild(modalButton.$el);
                              modalButton.btnClicked();
                          }).catch(error => {
                              // error
                              //Utils.handleErrorWithNotification('خطا هنگام بارگذاری لیست.', this.$noty);
                          }).then(() => {
                              EventBus.$emit('onRowToggleLoadingView', row.id);
                          });*/
          },
          onEditClicked: (row, context) => {
            this.editBankAccount(row);
          }
        }
      };
    },
    mounted() {
      EventBus.$on("bankAccountChanged", () => {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 100);
      });
      EventBus.$on("onReloadPageContent", () => {
        // reload current page
        this.show = !this.show;
        setTimeout(() => {
          this.show = !this.show;
        }, 100);
      });
    },
    methods: {
      viewBankAccount(data) {
        this.showModal("view", data);
      },
      editBankAccount(data) {
        this.showModal("edit", data);
      },
      createBankAccount() {
        this.showModal("create");
      },
      showModal(_mode, _data) {
        let ComponentClass = Vue.extend(BankAccountsModalButton);
        let baModal = new ComponentClass({
          propsData: {
            account: _data,
            params: {
              mode: _mode
            }
          }
        });
        baModal.$mount();
        this.$refs.container.appendChild(baModal.$el);
        setTimeout(() => {
          baModal.openModal();
        }, 50);
      },
      getTopButtons() {
        let buttonsComponents = [];

        let addItemButton = Vue.component("vs-button", {
          template: `<button @click="onClick" class="btn iconed btn-success"><i class="icon-plus"></i><span>اضافه کردن حساب جدید</span></button>`,
          methods: {
            onClick() {
              this.$emit("onToggleHeaderForms");
            }
          }
        });
        buttonsComponents.push(addItemButton);
        return buttonsComponents;
      }
    },
    beforeMount() {
      this.options.access = checkAccess(this.$route.path);
      this.show = this.options.access ? true : false;
    }
  };
</script>
